// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".suggestions-list{list-style:none;padding:0;margin:0;border:1px solid #ccc;background-color:#fff;position:absolute;width:100%;z-index:10;overflow-y:auto;max-height:10px}.suggestions-list li{padding:10px;cursor:pointer}.suggestions-list li:hover{background-color:#f0f0f0}.suggestion-type{font-size:12px;color:#999}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
